import React, { useEffect, useState } from "react";
import ReactTable from "../../../components/Table";
import { formatDateInTimeZone, FormatUSD } from "../../../utils/helpers/string";
import { useSelector } from "react-redux";
import { getCommissionList } from "../../../utils/apis/accountsApi";

// Custom debounce hook
const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

const CommissionHistory = () => {
  const [commissionHistory, setCommissionHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { idToken } = useSelector((state) => state.auth);

  const [params, setParams] = useState({
    page: 1,
    page_size: 20,
    search: "",
  });

  const debouncedSearch = useDebounce(params.search, 500);

  const fetchCommissionHistory = async () => {
    setIsLoading(true);
    try {
      const response = await getCommissionList(idToken, params);
      setCommissionHistory(response);
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCommissionHistory();
  }, [idToken, debouncedSearch, params.page, params.page_size]);

  const columns = [
    {
      Header: () => (
        <div className="header-with-icon">
          <span>Name</span>
        </div>
      ),
      accessor: "fullname",
      Cell: ({ value }) => (
        <div className="col-wrapper">
          <p>{value}</p>
        </div>
      ),
    },
    {
      Header: () => (
        <div className="header-with-icon">
          <span>Payment ID</span>
        </div>
      ),
      accessor: "payment_id",
      Cell: ({ value }) => (
        <div className="col-wrapper">
          <p>{value}</p>
        </div>
      ),
    },
    {
      Header: "Challenge Name",
      accessor: "challenge_name",
      Cell: ({ value }) => (
        <div className="col-wrapper">
          <p>{value || "N/A"}</p>
        </div>
      ),
    },
    {
      Header: "Payment Type",
      accessor: "payment_type",
      Cell: ({ value }) => (
        <div className="col-wrapper">
          <p style={{ textTransform: "capitalize" }}>
            {value?.replace("_", " ") || "N/A"}
          </p>
        </div>
      ),
    },
    {
      Header: "Payment Amount",
      accessor: "payment_amount",
      Cell: ({ value }) => (
        <div className="col-wrapper">
          <p>{value ? FormatUSD(value) : "N/A"}</p>
        </div>
      ),
    },
    {
      Header: "Commission Amount",
      accessor: "commission_amount",
      Cell: ({ value }) => (
        <div className="col-wrapper">
          <p>{value ? FormatUSD(value) : "N/A"}</p>
        </div>
      ),
    },
    {
      Header: "Promo Code",
      accessor: "promo_code",
      Cell: ({ value }) => (
        <div className="col-wrapper">
          <p>{value || "N/A"}</p>
        </div>
      ),
    },
    {
      Header: "Date",
      accessor: "created_at",
      Cell: ({ value }) => (
        <div className="col-wrapper">
          <p>{formatDateInTimeZone(value) || "N/A"}</p>
        </div>
      ),
    },
  ];

  return (
    <div className="ar-table">
      <div className="personal_info_form_input" style={{ maxWidth: "300px" }}>
        <label htmlFor="first_name" className="form_input_label">
          <input
            type="text"
            className="form_input_box"
            id="first_name"
            name="first_name"
            placeholder="Search"
            onChange={(e) => {
              setParams({
                ...params,
                search: e.target.value,
                page: 1, // Reset to first page on search
              });
            }}
          />
        </label>
      </div>
      <ReactTable
        columns={columns}
        data={commissionHistory || []}
        params={params}
        setParams={setParams}
        isLoading={isLoading}
      />
    </div>
  );
};

export default CommissionHistory;